import { comboboxAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { interactiveTransition } from "./_shared";

export default defineSlotRecipe({
  slots: comboboxAnatomy.keys(),
  base: {
    input: {
      ...interactiveTransition,
    },
    // Chakra base puts Combobox.content on l2; we lift it to l3 so the
    // dropdown matches Menu/Popover/HoverCard. Input and item ride the
    // cascade (l2 / l1).
    content: {
      borderRadius: "l3",
    },
    item: {
      _highlighted: {
        bg: {
          base: "bg.emphasized/80",
          _dark: "gray.800",
        },
      },
    },
    itemIndicator: {
      position: "absolute",
      right: 0,
      top: 0,
      bottom: 0,
    },
  },

  variants: {
    variant: {
      outline: {},
      subtle: {
        input: {
          borderWidth: "1px",
          borderColor: "transparent",
          bg: "bg.muted",
        },
      },
      inline: {
        root: {
          width: "fit-content",
        },
        content: {
          minWidth: "fit-content",
        },
        input: {
          borderRadius: 0,
          border: "none",
          pl: 0,
          pr: 12,
          maxWidth: "120px",
          fontSize: "normal",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          _placeholder: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        },
        valueText: {
          maxWidth: "100%",
        },
      },
    },
  },

  defaultVariants: {
    variant: "outline",
  },
});
